import axios from "axios";
import { toast } from "react-toastify";
export const GetBookUnits = (data) => {
  return {
    type: "get_bookunits",
    payload: data,
    loader: false,
  };
};
export function getBookUnit() {
  return (dispatch) => {
    axios({
      url: `${process.env.REACT_APP_API_URL}Leads/GetAllBookingUnits`,
      method: "get",
      headers: {
        Authorization: `Bearer ${localStorage.getItem("token")}`,
        "content-type": "application/json",
      },
    }).then(
      (result) => {
        if (result.data.IsSuccess === true) {
          dispatch(GetBookUnits(result.data));
        } else {
          toast.info(result.data.Message);
        }
      },
      (error) => {
        toast.info("Something went wrong!");
      }
    );
  };
}
